/**
 * Compra Inteligente Service
 */

import api from './api'

export const compraInteligenteService = {
  getDashboard: async () => {
    const response = await api.get('/api/purchases/intelligence/dashboard')
    return response.data
  },

  getAlerts: async (params = {}) => {
    const response = await api.get('/api/purchases/intelligence/alerts', { params })
    return response.data
  },

  getBrands: async () => {
    const response = await api.get('/api/purchases/intelligence/brands')
    return response.data
  },

  recalculateMinimum: async (body) => {
    const response = await api.post('/api/purchases/intelligence/recalculate-minimum', body)
    return response.data
  },

  getSuggestions: async (params = {}) => {
    const response = await api.get('/api/purchases/intelligence/suggestions', { params })
    return response.data
  },

  getSuppliersForPackages: async () => {
    const response = await api.get('/api/purchases/intelligence/suppliers-for-packages')
    return response.data
  },

  getSupplierPackage: async (supplierId) => {
    const response = await api.get(`/api/purchases/intelligence/suggestions/supplier/${supplierId}`)
    return response.data
  },

  generateRequisitions: async (body) => {
    const response = await api.post('/api/purchases/intelligence/suggestions/generate-requisitions', body)
    return response.data
  },

  prepareRequisitions: async (body) => {
    const response = await api.post('/api/purchases/intelligence/suggestions/prepare-requisitions', body)
    return response.data
  },

  listBrandPolicies: async () => {
    const response = await api.get('/api/purchases/intelligence/policies/brands')
    return response.data
  },

  createBrandPolicy: async (body) => {
    const response = await api.post('/api/purchases/intelligence/policies/brands', body)
    return response.data
  },

  updateBrandPolicy: async (id, body) => {
    const response = await api.put(`/api/purchases/intelligence/policies/brands/${id}`, body)
    return response.data
  },

  deleteBrandPolicy: async (id) => {
    const response = await api.delete(`/api/purchases/intelligence/policies/brands/${id}`)
    return response.data
  },

  getProjection: async (params = {}) => {
    const response = await api.get('/api/purchases/intelligence/projection', { params })
    return response.data
  },

  getRiskDistribution: async () => {
    const response = await api.get('/api/purchases/intelligence/risk-distribution')
    return response.data
  },

  getSeasonal: async (brand) => {
    const response = await api.get(`/api/purchases/intelligence/seasonal/${encodeURIComponent(brand)}`)
    return response.data
  },

  getMonthlyConsumption: async (brand, months = 12) => {
    const response = await api.get(
      `/api/purchases/intelligence/seasonal/${encodeURIComponent(brand)}/consumption`,
      { params: { months } }
    )
    return response.data
  },

  applySeasonal: async (brand, productCodes = null) => {
    const response = await api.post(
      `/api/purchases/intelligence/seasonal/${encodeURIComponent(brand)}/apply`,
      productCodes ? { productCodes } : {}
    )
    return response.data
  },

  runBackfill: async (years = 2) => {
    const response = await api.post('/api/purchases/intelligence/jobs/backfill', { years })
    return response.data
  },

  analyzeAi: async (productIds) => {
    const response = await api.post('/api/purchases/intelligence/analyze-ai', { productIds })
    return response.data
  }
}
